import styled from "styled-components";

import TableContainer from "@material-ui/core/TableContainer";
import TableDefault from "../../grid/TableDefault";

const primary = (props) => props.theme.palette.primary;
const blue = (props) => props.theme.palette.blue;

export const CustomContainer = styled(TableContainer)`
  table thead tr th.MuiTableCell-stickyHeader {
    top: -1px;
    background-color: #d6e5ff;
  }
`;

export const Table = styled(TableDefault)``;

export const CustomTable = styled.div`
  ${Table} {
    .MuiPaper-root.makeStyles-paper-13.MuiPaper-elevation1 {
      box-shadow: none;
    }
  }

  ${CustomContainer} {
    &::-webkit-scrollbar {
      width: 10px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 5px;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: ${primary};
      border-radius: 5px;
      border: 1px solid #f1f1f1;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: ${blue};
    }
  }
`;
